/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
// Importing necessary dependencies for translations, state management, and file exports
import { useTranslation } from "react-i18next"; // for handling translations
import {useEffect, useState} from "react"; // React hooks for component state and lifecycle
import {toast} from "react-toastify";
import {MODULE_EXPORT_DATA_MODEL} from "../Model/Model";
import HandleChange from "../../../Helpers/HandleChange";
import {errorMsg} from "../../../Apis/functions";
import {useDispatch} from "react-redux";
import {ExportModuleData} from "../../../reduxToolkit/Files/FilesApi"; // Redux hooks for dispatching actions and accessing state

// Component to handle file exports (PDF/Excel) with dynamic headers and user filtering
const ModuleExportDataApp = ({
                                 onHide,
                                 excel,
                                 endPoint,
                                 renderEndPoint,
                                 exportModuleDataOption
}) => {
    const { t } = useTranslation(); // Translation hook
    const dispatch = useDispatch();
    const [item, setItem] = useState(MODULE_EXPORT_DATA_MODEL);
    const [emptyFields, setEmptyFields] = useState(false);
    const [isValidRange, setIsValidRange] = useState(false);
    const { handleChange } = HandleChange({ model: item, setModel: setItem });

    useEffect(() => {
        setIsValidRange(item.isValidRange())
    },[
       item?.attendanceStartDate,
       item?.attendanceEndDate
    ]);

    const handleDownload = () => {
        if(!item.isValid() || !isValidRange){
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);
        let body = item.toRegister(exportModuleDataOption, excel);
        body = renderEndPoint ? renderEndPoint(body) : body;

        dispatch(endPoint ? endPoint(body) : ExportModuleData(body))
            .then((resp) => {
                const { payload: { status } } = resp;
                if (status === 200) {
                    toast.success(t('file_generation_in_progress'));
                    item.clear();
                    onHide();
                }  else errorMsg();
            })
            .catch(() => errorMsg());
    }
    // Returning all necessary handlers and state for use in the component
    return {
        t,
        item,
        emptyFields,
        isValidRange,
        handleDownload,
        handleChange
    };
};

// Exporting the component for use in other parts of the application
export default ModuleExportDataApp;
